import { useState } from 'react';
import sizeRef from './media/video-size-ref.png';
import './scss/ImageSlider.scss';

function ImageSlider({ images }) {

  const [currentImage, setCurrentImage] = useState(0)

  function prev() {
    if (currentImage > 0) {
      setCurrentImage(currentImage - 1)
    }
  }

  function next() {
    if (currentImage < images.length -1) {
      setCurrentImage(currentImage + 1)
    }
  }

  return (
    <div className="image-slider">
      <div className="progress-screen">
        {images.map((image, index) => 
          <div 
            data-index={index} 
            className={index === currentImage ? 'active' : 'inactive'}
            style={{width: `calc(100% / ${images.length})` }}
            key={index}>
          </div>
        )}
      </div>
      <div className="prev-pause-next-screen">
        <div className="prev-button" onClick={prev}></div>
        <div className="next-button" onClick={next}></div>
      </div>
      <img src={images[currentImage]} />       
    </div>
  );
}

export default ImageSlider;
